export default "__VITE_ASSET__CHB$PiOM__"